import './css/about.css'
import React, {Component} from 'react';
import { Loader, Icon, Card,  Grid } from 'semantic-ui-react'


export default class About extends Component {
	
	constructor() {
		super();
	}

	render(){
				
		console.log(this.props.text);
		if(!this.props.text) return (<Loader active>cargando...</Loader>)

		let text = this.props.text.map((d,i)=>(d["gsx$faq"].$t));
		
		return (
			<div id="about">

			<h3 dangerouslySetInnerHTML={{__html:text[0]}}></h3>
			
			<div>
			<p dangerouslySetInnerHTML={{__html:text[1]}}></p>
			<p dangerouslySetInnerHTML={{__html:text[2]}}></p>
			<p dangerouslySetInnerHTML={{__html:text[3]}}></p>
			</div>

		</div>);

	}
}


// WEBPACK FOOTER //
// ./src/About.js